import endpoints from "../../endpoints";
import axios from "axios";
import {handleError, handleResponse} from "./apiUtils";

// TODO update api call structure to use a singleton design pattern.


// Auth Calls
export function registerUserEndpointCall(params, callback) {
    const url = endpoints.register;
    return axios.post(url, params)
        .then(handleResponse)
        .catch(handleError);
}

export function loginUserEndpointCall(params, callback) {
    const url = endpoints.login;
    return axios.post(url, params)
        .then(handleResponse)
        .catch(handleError);
}

export function getUser(id, authToken) {
    const url = endpoints.authUser(id);

    const config = {
        headers: {
            'Authorization': `Bearer ${authToken}`
        }
    };

    return axios.get(url, config)
        .then(handleResponse)
        .catch(handleError);
}
